import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiZap, FiShield, FiStar } = FiIcons;

const Pricing = () => {
  const plans = [
    {
      name: 'Pay as you go',
      price: '0',
      description: 'Perfect for individual audits',
      features: ['Single assessment access', 'AI Analysis reports', 'Actionable roadmaps', '30-day data retention'],
      cta: 'Browse Catalog',
      highlight: false
    },
    {
      name: 'Unlimited Pro',
      price: '49',
      description: 'For growing businesses',
      features: [
        'All assessments included',
        'Unlimited AI Analysis',
        'Team collaboration tools',
        'Custom report builder',
        'Priority support',
        'Historical trend tracking'
      ],
      cta: 'Start Free Trial',
      highlight: true
    },
    {
      name: 'Enterprise',
      price: '199',
      description: 'Full strategic oversight',
      features: [
        'Everything in Pro',
        '4 Expert Review sessions/yr',
        'White-labeled reports',
        'API Access',
        'Dedicated account manager',
        'Custom assessment builder'
      ],
      cta: 'Contact Sales',
      highlight: false
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">Simple, Transparent Pricing</h1>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">Choose the plan that fits your execution pace. Scale up as you grow.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {plans.map((plan, i) => (
            <motion.div
              key={plan.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className={`relative bg-white rounded-[2.5rem] p-10 border-4 transition-all ${
                plan.highlight ? 'border-blue-600 shadow-2xl scale-105 z-10' : 'border-gray-50 shadow-xl'
              }`}
            >
              {plan.highlight && (
                <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-blue-600 text-white px-6 py-1.5 rounded-full text-xs font-black uppercase tracking-widest">
                  Most Popular
                </div>
              )}
              
              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-500 text-sm">{plan.description}</p>
              </div>

              <div className="mb-8 flex items-baseline gap-1">
                <span className="text-4xl font-black text-gray-900">${plan.price}</span>
                <span className="text-gray-400 font-bold">/mo</span>
              </div>

              <button className={`w-full py-4 rounded-2xl font-bold mb-10 transition-all ${
                plan.highlight ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-xl shadow-blue-100' : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
              }`}>
                {plan.cta}
              </button>

              <div className="space-y-4">
                {plan.features.map((f, j) => (
                  <div key={j} className="flex items-start gap-3">
                    <SafeIcon icon={FiCheck} className="text-green-500 mt-1 flex-shrink-0" />
                    <span className="text-sm text-gray-600 font-medium">{f}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pricing;